import loadReduxAction from 'modules/redux/actions/load'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import getCurrentIdTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current-id'
import { interpolateStringUtil } from '@gymaholic/packages/src/utils/string/interpolate'
import { logUtil } from 'packages/src'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import { REDUX_ACTION_PREFIX } from '@gymaholic/packages/src/modules/redux/constants/action.js'
import { USER_KEY } from '@gymaholic/packages'
import {
  SUBSCRIPTION_CLASS_NAME,
  SUBSCRIPTIONS_ENDPOINT,
  SUBSCRIPTIONS_PATH
} from 'modules/training/modules/subscription/constants'

export function loadSubscriptionsAction () {
  return async (dispatch, getState) => {
    const id = getCurrentIdTrainingUserSelect(getState())
    const logPrefix = `userId=${id}`

    if (!id) {
      logUtil('loadSubscriptionsAction').debug(`${logPrefix} [noop] no id`)
      return
    }

    logUtil('loadSubscriptionsAction').debug(`${logPrefix} [start]`)
    try {
      await dispatch(
        loadReduxAction({
          type: getActionStrReduxUtil(REDUX_ACTION_PREFIX.LOAD, USER_KEY.SUBSCRIPTION_PLANS),
          payload: {
            endpoint: getEndpointTrainingUtil(
              interpolateStringUtil(SUBSCRIPTIONS_ENDPOINT.GET_SUBSCRIPTIONS_BY_ID, { id })
            ),
            className: SUBSCRIPTION_CLASS_NAME,
            domainListPath: SUBSCRIPTIONS_PATH.ALL
          }
        })
      )
    } catch (error) {
      logUtil('loadSubscriptionsAction').error(`${logPrefix} error=`, error)
    }
  }
}
